"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$create = require("@babel/runtime-corejs3/core-js-stable/object/create");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _indexOfInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/index-of");

var _Object$assign = require("@babel/runtime-corejs3/core-js-stable/object/assign");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.object.assign.js");

require("core-js/modules/web.dom-collections.for-each.js");

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;

    _Object$defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var MessageTags = require('./messagetags');

module.exports = /*#__PURE__*/function () {
  function IrcMessage(command) {
    _classCallCheck(this, IrcMessage);

    this.tags = _Object$create(null);
    this.prefix = '';
    this.nick = '';
    this.ident = '';
    this.hostname = '';
    this.command = command || '';

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    this.params = args || [];
  }

  _createClass(IrcMessage, [{
    key: "to1459",
    value: function to1459() {
      var _this = this;

      var parts = [];
      var tags = MessageTags.encode(this.tags);

      if (tags) {
        parts.push('@' + tags);
      }

      if (this.prefix) {
        // TODO: If prefix is empty, build it from the nick!ident@hostname
        parts.push(':' + this.prefix);
      }

      parts.push(this.command);

      if (this.params.length > 0) {
        var _context;

        _forEachInstanceProperty(_context = this.params).call(_context, function (param, idx) {
          if (idx === _this.params.length - 1 && (_indexOfInstanceProperty(param).call(param, ' ') > -1 || param[0] === ':')) {
            parts.push(':' + param);
          } else {
            parts.push(param);
          }
        });
      }

      return parts.join(' ');
    }
  }, {
    key: "toJson",
    value: function toJson() {
      return {
        tags: _Object$assign({}, this.tags),
        source: this.prefix,
        command: this.command,
        params: this.params
      };
    }
  }]);

  return IrcMessage;
}();